import { createActionGroup, props } from '@ngrx/store';

export const studentAdmissionActions = createActionGroup({
  source: 'student-admission',
  events: {
    'fill id card form': props<{ data: FormData; noRedirect?: boolean }>(),
    'update id card form': props<{ data: FormData; id: string }>(),
  },
});
